import type { EdgeId } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetPathLookupPathInspectorHighlightedEdgeHoveredCommand {
  edgeId: EdgeId;
  hovered: boolean;
}

export const setPathLookupPathInspectorHighlightedEdgeHovered: GraphCommandFactory<
  SetPathLookupPathInspectorHighlightedEdgeHoveredCommand
> = (cmdContext) => (command) => {
  const {
    pathlookup: {
      pathInspector: { highlightedEdges, activeNodeSn },
    },
  } = cmdContext.getState();
  if (
    // Fixed noUncheckedIndexedAccess NIM-19408
    activeNodeSn !== null &&
    highlightedEdges[activeNodeSn] !== undefined &&
    (highlightedEdges[activeNodeSn]?.incomingEdges.includes(command.edgeId) ||
      highlightedEdges[activeNodeSn]!.outgoingEdges.includes(command.edgeId))
  ) {
    cmdContext.updateState((draft) => {
      draft.pathlookup.pathInspector.hoveredEdge = command.hovered
        ? command.edgeId
        : null;
    });
  }
};
